module.exports = __webpack_public_path__ + "assets/img/kongtiao.e0edf820.jpg";